import { Box, HStack, Stack, useDisclosure } from "@chakra-ui/react";
import React from "react";
import { useNavigate } from "react-router";
import SearchInput from "../../../components/shared/SearchInput";
import { useListCohorts } from "../../../services/api/cohorts/queries/useListCohorts";
import useReadCohort from "../../../services/api/cohorts/queries/useReadCohort";
import { ICohort } from "../../registries/models/Cohort";
import CohortGrid from "./CohortGrid";
import { DeleteCohortModal } from "./DeleteCohortModal";
import { EditCohortModal } from "./EditCohortModal";

const Cohorts = () => {
  const [cohortSearch, setCohortSearch] = React.useState("");
  const [editCohort, setEditCohort] = React.useState<ICohort>();
  const [deleteCohort, setDeleteCohort] = React.useState<ICohort>();

  const navigate = useNavigate();

  const {
    isOpen: isOpenEditCohortModal,
    onOpen: onOpenEditCohortModal,
    onClose: onCloseEditCohortModal,
  } = useDisclosure();
  const {
    isOpen: isOpenDeleteCohortModal,
    onOpen: onOpenDeleteCohortModal,
    onClose: onCloseDeleteCohortModal,
  } = useDisclosure();

  const { data, isLoading } = useListCohorts();

  const { data: dataCohort } = useReadCohort(
    editCohort?.id || deleteCohort?.id
  );

  const handleOnEditCohort = (cohort: ICohort) => {
    setEditCohort(cohort);
    onOpenEditCohortModal();
  };

  const handleOnDeleteCohort = (cohort: ICohort) => {
    setDeleteCohort(cohort);
    onOpenDeleteCohortModal();
  };

  const handleOnClickCohort = (cohort: ICohort) => {
    navigate(`/app/cohorts/${cohort.id}`);
  };

  return (
    <>
      <Box h="full">
        <Stack spacing={8}>
          <HStack justify={"space-between"}>
            <SearchInput
              search={cohortSearch}
              setSearch={setCohortSearch}
              placeholder="Search cohorts"
            ></SearchInput>
          </HStack>
          <CohortGrid
            isLoading={isLoading}
            cohorts={data}
            search={cohortSearch}
            setSearch={setCohortSearch}
            onClickCohort={handleOnClickCohort}
            onEditCohort={handleOnEditCohort}
            onDeleteCohort={handleOnDeleteCohort}
          ></CohortGrid>
        </Stack>
      </Box>

      {dataCohort && (
        <EditCohortModal
          isOpen={isOpenEditCohortModal}
          onClose={onCloseEditCohortModal}
          cohort={dataCohort}
        ></EditCohortModal>
      )}
      {deleteCohort && dataCohort && (
        <DeleteCohortModal
          isOpen={isOpenDeleteCohortModal}
          onClose={onCloseDeleteCohortModal}
          cohort={dataCohort}
        ></DeleteCohortModal>
      )}
    </>
  );
};

export default Cohorts;
